import { cn, useMedias } from '@divlab/divanui';

import Img from '@UI/Img';
import useTranslation from '@Queries/useTranslation';
import Text from '@Promo/elems/Text';
import styles from './Category.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { CategoryData } from '../../../../typings';

interface CategoryProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  category: CategoryData;
  reverse?: boolean;
  analyticsTitle: string;
}

const Category: FC<CategoryProps> = (props) => {
  const { className, category, reverse, ...restProps } = props;

  const { isMobile } = useMedias();
  const { t } = useTranslation();

  return (
    <div
      className={cn(styles.grid, className, { [styles.reverse]: reverse })}
      id={category.id}
      {...restProps}
    >
      <div className={styles.imgWrapper}>
        <Img
          className={styles.imageContainer}
          cnImage={styles.image}
          src={category.image}
          loading='lazy'
        />
      </div>

      <div className={cn(styles.text, { [styles.reversedText]: reverse })}>
        <Text
          className={styles.subtitle}
          desktop={t(`items.${category.name}.title`)}
          isMobile={isMobile}
        />
        <Text className={styles.description} desktop={t(`items.${category.name}.subtitle`)} />
      </div>
    </div>
  );
};

export default Category;
